import { render, staticRenderFns } from "./CardCompanyPlan.vue?vue&type=template&id=67f70ef5&scoped=true"
import script from "./CardCompanyPlan.vue?vue&type=script&lang=js"
export * from "./CardCompanyPlan.vue?vue&type=script&lang=js"
import style0 from "./CardCompanyPlan.vue?vue&type=style&index=0&id=67f70ef5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f70ef5",
  null
  
)

export default component.exports